import { create } from 'zustand';

import { PAYMENT_TYPE } from '@savgroup-front-common/types/Payment';
import { UserPreferences } from '@savgroup-front-common/types/User';

import { adaptUserToLoginState } from './adapters/adaptUserToLoginState';
import { LoginState } from './types';

interface LoginStore {
  login: LoginState;
  setPreferences: (preferences: UserPreferences) => void;
  setLoginStore: (login: LoginState) => void;
}

export const useLoginStore = create<LoginStore>((set) => ({
  login: {
    assignedSites: {
      sites: [],
      allowAllForSellers: {
        store: [],
        repairer: [],
        supplier: [],
        warehouse: [],
      },
    },
    id: '',
    isLoaded: false,
    isLoggedIn: false,
    userId: '',
    tenantId: '',
    firstname: '',
    lastname: '',
    mail: '',
    failure: false,
    errors: [],
    assignedStoresIds: [],
    accesses: [],
    rolePermissions: [],
    preferences: {
      language: '',
      communicationChannel: 'Email',
      lastSelectedStore: '',
      sellerPreferences: [],
      selectedWidgets: [],
    },
    roles: [],
    permissions: [],
    profiles: [],
    paymentType: PAYMENT_TYPE.IMMEDIATE,
  },

  setLoginStore: (login: LoginState) => {
    set((state) => ({
      login: adaptUserToLoginState({
        currentState: state.login,
        payload: login,
      }),
    }));
  },

  setPreferences: (preferences: UserPreferences) => {
    set((state) => ({
      login: {
        ...state.login,
        preferences,
      },
    }));
  },
}));

export const useCurrentUser = () => {
  const login = useLoginStore((state) => state.login);

  return login;
};
